import Dispatcher from 'dispatcher/appDispatcher';
import ActionType from 'constants/actionType';
import { appBannerApi } from '../api/appBannerApi';

class AppBannerAction {

  async getBannerData() {
    return appBannerApi.getBannerData();
  }

  setBannerContent(content) {
    Dispatcher.dispatchAsync({
      actionType: ActionType.APP_BANNER_SET_CONTENT,
      content
    });
  }

}

export const appBannerAction = new AppBannerAction();
